<template>
    <div>
        <div>
            <el-button size="mini" icon="el-icon-plus" @click="addTag">添加知识点</el-button>
        </div>
        <br>
        <el-table style="width: 100%" :data="tagList">
            <el-table-column type="index" width="80"></el-table-column>
            <el-table-column prop="tagId" label="ID" width="80"></el-table-column>
            <el-table-column prop="tagName" label="名称"></el-table-column>
            <!-- <el-table-column prop="isPrivate" label="isPrivate"></el-table-column> -->
            <el-table-column prop="memo" label="描述"></el-table-column>
            <!-- <el-table-column prop="creator" label="创建人"></el-table-column> -->
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="editTag(scope.row)">修改</el-button>
                    <!-- <el-button size="mini" type="warning">禁用</el-button> -->
                    <el-button size="mini" type="danger" @click="handleDelTag(scope.row.tagId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog width="30%"
                :title="`${activeTag.tagId ? '编辑' : '添加'}知识点`"
                :visible.sync="tagVisible"
        >
            <div>
                <el-form ref="tagForm" :model="activeTag" :rules="rules" size="mini" label-width="100px">
                    <el-form-item label="ID：" prop="tagId">
                        <el-input disabled v-model.number="activeTag.tagId"></el-input>
                    </el-form-item>
                    <el-form-item label="名称：" prop="tagName">
                        <el-input v-model="activeTag.tagName"></el-input>
                    </el-form-item>
                    <el-form-item label="创建人：" prop="creator">
                        <el-input disabled v-model="activeTag.creator"></el-input>
                    </el-form-item>
                    <el-form-item label="isPrivate：" prop="isPrivate">
                        <el-input disabled v-model.number="activeTag.isPrivate"></el-input>
                    </el-form-item>
                    <el-form-item label="描述：" prop="isPrivate">
                        <el-input type="textarea" v-model="activeTag.memo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button @click="tagVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getEttagList, editEttag, delEttag } from '@/api/exam/ettag';
export default {
    data () {
        return {
            tagList: [],
            tagVisible: false,
            activeTag: {},
            rules: {
                tagName: [
                    { required: true, message: '请输入知识点名称', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        init () {
            this.getTags()
        },
        addTag () {
            this.activeTag = {}
            this.tagVisible = true
        },
        editTag (row) {
            this.activeTag = row
            this.tagVisible = true
        },
        handleSave () {
            this.$refs['tagForm'].validate(valid => {
                if (valid) {
                    this.tagVisible = false
                    this.submitTag()
                }
            })
        },
        handleDelTag (id) {
            this.$confirm('此操作将永久删除该知识点, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delTag(id);
            }).catch(()=>{})
        },
        getTags () {
            getEttagList().then(res => {
                this.tagList = res
            })
        },
        submitTag () {
            editEttag(this.activeTag).then(() => {
                this.$message.success('操作成功');
                this.getTags();
            })
        },
        delTag (id) {
            delEttag(id).then(() => {
                this.$message.success('删除成功');
                this.getTags();
            });
        }
    },
    created () {
        this.init()
    }
}
</script>